// store/modules/configuration.ts
import {
  ActionContext,
  ActionTree,
  GetterTree,
  Module,
  MutationTree
} from "vuex";
import { RootState } from "../store";
import configurationUseCases from "../../../../domain/usecase/impl/configuration/configurationUseCases";
import { Configuration } from "../../../../domain/entities/configuration";

class ConfigurationState {
  configuration: Configuration = (() => {
    const stored = localStorage.getItem("configuration");
    return stored
      ? Object.assign(new Configuration(), JSON.parse(stored))
      : new Configuration();
  })();
}

const state = new ConfigurationState();

const mutations: MutationTree<ConfigurationState> = {
  SET_CONFIGURATION(state, configuration: Configuration) {
    state.configuration = configuration;
  }
};

const actions: ActionTree<ConfigurationState, RootState> = {
  async get({ commit }) {
    try {
      const response: Configuration = await configurationUseCases.get();
      commit("SET_CONFIGURATION", response);
      localStorage.setItem("configuration", JSON.stringify(response));
      return response;
    } catch (e) {
      commit("SET_CONFIGURATION", new Configuration());
      localStorage.removeItem("configuration");
      console.error(e);
      throw e;
    }
  }
};

const getters: GetterTree<ConfigurationState, RootState> = {
  configuration(state) {
    return state.configuration;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
} as Module<ConfigurationState, RootState>;
